export const CountryCodes = {
  Australia: 'AU',
  UK: 'UK',
  NewZealand: 'NZ',
  Singapore: 'SG',
  GreatBritain: 'GB',
} as const;

export type CountryCodes = (typeof CountryCodes)[keyof typeof CountryCodes];
